export default "__VITE_ASSET__BP_hMoSk__"